import ViewBase from "../../view-base.view";
import DatePickerComponent from "../../../components/date-picker/date-picker.component";
import SelectUserComponent from "../../../components/user/select-user.component";
import scheduleUploadModel from "../../../models/schedule/schedule-upload.model";
import userModel from "../../../models/user/user.model";
import moment from "moment";
import { formats as FORMATS } from "../../../config/constants";

export default function ScheduleExcelUploadView() {

  ViewBase.call(this);

  let needRefresh = false;
  let fileUploaded = false;
  let userOptionList;
  let selectedUserList = [];

  let downloadTemplate = () => {
    this.showLoading();
    scheduleUploadModel.downloadTemplate(
      (result) => {
        // console.log('downloadTemplate - result:', result)
        this.hideLoading();
      },
      (error) => {
        this.hideLoading();
        this.handleError(error);
      },
    );
  }

  let downloadSimpleTemplate = () => {
    this.showLoading();
    scheduleUploadModel.downloadSimpleTemplate()
      .catch((error) => { this.handleError(error) })
      .finally(() => {
        this.hideLoading();
      });
  }

  let uploadTemplate = (uploadForm) => {
    this.showLoading();
    scheduleUploadModel.uploadTemplate(
      (result) => {
        fileUploaded = true;
        this.hideLoading();
        this.showMessage(
          this.getText('EM00000312', 'Please check the detailed upload result in the downloaded file'),
          this.getText('EM00000313', 'Upload Completed'),
        );
      },
      (error) => {
        this.hideLoading();
        this.handleError(error);
      },
      uploadForm
    );
  }

  let uploadSimpleTemplate = (uploadForm) => {
    this.showLoading();
    scheduleUploadModel.uploadSimpleTemplate(
      (result) => {
        fileUploaded = true;
        this.hideLoading();
        this.showMessage(
          this.getText('EM00000312', 'Please check the detailed upload result in the downloaded file'),
          this.getText('EM00000313', 'Upload Completed'),
        );
      },
      (error) => {
        this.hideLoading();
        this.handleError(error);
      },
      uploadForm
    );
  }

  let submitDownloadTemplate = (e, isSimpleUpload) => {
    e.preventDefault();

    if (isSimpleUpload) {
      downloadSimpleTemplate();
      return;
    }

    // Validate download form
    e.target.classList.add('was-validated');
    if (!e.target.checkValidity() || scheduleUploadModel.isDownloadFormEmpty()) {
      // console.log('checkValidity');
      e.stopPropagation();
      return;
    }
    downloadTemplate();
  }

  let submitUploadTemplate = (e, isSimpleUpload) => {
    e.preventDefault();
    // Validate upload form
    e.target.classList.add('was-validated');
    if (!e.target.checkValidity()) {
      // console.log('checkValidity');
      e.stopPropagation();
      return;
    }

    let fileInput = document.getElementById('file-upload');
    var files = fileInput.files;
    var uploadFormData = new FormData();
    for (var i = 0; i != files.length; i++) {
      uploadFormData.append("file", files[i]);
    }

    isSimpleUpload ? uploadSimpleTemplate(uploadFormData) : uploadTemplate(uploadFormData);
  }

  let closeModal = function () {
    if (fileUploaded) {
      needRefresh = true;
    }
    onClose(false);
  }

  let onClose = (isModalOpen) => { }

  let triggerRefresh = (needRefresh) => { }

  return {
    oninit: (vnode) => {
      this.showLoading();

      if (vnode.attrs.onClose) {
        onClose = vnode.attrs.onClose;
      }

      if (vnode.attrs.triggerRefresh) {
        triggerRefresh = vnode.attrs.triggerRefresh;
      }

      scheduleUploadModel.resetDownloadForm();

      userOptionList = [];
      userModel.getUserListBySupervisor().then(data => {
        data.map(d => {
          userOptionList.push({
            "id": d.userID,
            "code": d.userID,
            "name": d.userName,
          });
        });
      }).catch(error => {
        this.handleError(error);
      }).then(() => {
        this.hideLoading();
      })
    },
    oncreate: (vnode) => {
    },
    onupdate: (vnode) => {
    },
    onremove: (vnode) => {
      triggerRefresh(needRefresh);
      scheduleUploadModel.resetDownloadForm();
    },
    view: (vnode) => {
      return [
        m('.container',
          m('form#download-template-form.row.g-4.needs-validation[novalidate]',
            {
              onsubmit: (e) => { submitDownloadTemplate(e, vnode.attrs.isSimpleUpload) }
            },
            m('.col-12',
              m('.fw-bold', '1. ',
                vnode.attrs.isSimpleUpload ? this.getText('', 'Download Simple Template') : this.getText('LT00000218', 'Download Template'),
              ),
            ),
            !vnode.attrs.isSimpleUpload && [
              m('.col-12',
                m('.row.g-2.g-sm-3.align-items-center',
                  m('.offset-sm-1.col-sm-2.text-sm-end',
                    m('label[for=users]', this.getText("LT00000219", "Users")),
                  ),
                  m('.col-sm-7.position-relative',
                    m(SelectUserComponent, {
                      default: {
                        userStatusCode: '0001'
                      },
                      required: true,
                      onSelect: (s) => {
                        // console.log('Selected users - onSelect: ', s)
                        selectedUserList = s;
                        scheduleUploadModel.reqParams.userIDs = selectedUserList.map(o => o.userID);
                      },
                      selectedUserList: selectedUserList,
                    }),
                    m('.invalid-tooltip', this.getText("EM00000314", "Please select user(s)")),
                  )
                )
              ),
              m('.col-12',
                m('.row.g-2.g-sm-3.align-items-center',
                  m('.offset-sm-1.col-sm-2.text-sm-end',
                    m('label[for=schedule-excel-upload--period]', this.getText("LT00000150", "Period")),
                  ),
                  m('.col-sm-7.position-relative',
                    m(DatePickerComponent, {
                      readonly: true,
                      required: true,
                      id: 'schedule-excel-upload--period',
                      class: 'form-control',
                      isRange: true,
                      dateStart: moment(scheduleUploadModel.reqParams.fromDate).format(FORMATS.dateFormat),
                      dateEnd: moment(scheduleUploadModel.reqParams.toDate).format(FORMATS.dateFormat),
                      minDate: moment().add(1, 'day').format(FORMATS.dateFormat),
                      onselect: (e) => {
                        scheduleUploadModel.reqParams.fromDate = moment(e.detail.start).format(FORMATS.apiDateFormat);
                        scheduleUploadModel.reqParams.toDate = moment(e.detail.end).format(FORMATS.apiDateFormat);
                      }
                    }),
                    m('.invalid-tooltip', this.getText("EM00000315", "Please select dates")),
                  ),
                )
              ),
            ],
            m('.col-12',
              m('.row.g-2.g-sm-3.align-items-center.justify-content-end',
                m('.col-sm-8.offset-sm-2.text-end',
                  m('button.btn.btn-primary[type=submit]',
                    m('i.bi.bi-file-earmark-arrow-down'),
                    vnode.attrs.isSimpleUpload ? this.getText("", "Simple Excel Template") : this.getText("LT00000220", "Excel Template"),
                  ),
                ),
                m('.col-sm-2'),
              )
            ),
          ),
          m('hr'),
          m('form.row.g-4.needs-validation[novalidate]', {
            onsubmit: (e) => { submitUploadTemplate(e, vnode.attrs.isSimpleUpload) }
          },
            m('.col-12',
              m('.fw-bold', '2. ', this.getText('LT00000197', 'Excel Upload')),
            ),
            m('.col-12',
              m('.row.g-2.g-sm-3.align-items-center',
                m('.col-sm-8.offset-sm-2.position-relative',
                  m('input#file-upload.form-control[type=file][required]'),
                  m('.invalid-tooltip', this.getText("EM00000316", "Please select a file")),
                ),
              )
            ),
            m('.col-12',
              m('.row.g-2.g-sm-3.align-items-center.justify-content-end',
                m('.col-sm-8.offset-sm-2.text-end',
                  m('.d-flex.justify-content-end.mb-3', { style: 'gap: 0.75em' },
                    m('button.btn.btn-primary[type=submit]', this.getText("LT00000290", "Upload")),
                    m('button.btn.btn-white[type=button]', { onclick: closeModal }, this.getText("LT00000021", "Close")),
                  ),
                ),
                m('.col-sm-2'),
              )
            ),
          ),
        ),
        this.getBaseViews()
      ]
    }
  }

}